export const greenDark = '#1f8456'
export const greenLight = '#21ba45'

export const blueLight = '#2185d0'
export const blueLogo = '#071d39'

export const white = '#FFFFFF'

export const orange = '#f2711c'
